<div class="modal-header">
    <h4 md-dialog-title class="modal-title pull-left">{{ data.Header }}</h4>
</div>
<div class="modal-body">
    <mat-dialog-content>
        <div [innerHTML]="data.Body"></div>
        <div class="radio-options">
             <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedOption">
                <mat-radio-button *ngFor="let control of data.AppealControlArray" [value]="control.Action" [checked]="control.Action == selectedOption"> {{control.Text}}</mat-radio-button>
            </mat-radio-group> 
        </div>
    </mat-dialog-content>
</div>

<div class="modal-footer">
    <mat-dialog-actions class="btn-container">
        <button class="btn" [class.btn-primary]="control.Action === 'YES'"
            [class.btn-secondary]="control.Action !== 'YES'" md-raised-button
            *ngFor="let control of data.ControlArray; let ftIndex = index" 
            (click)="onClose()">{{ control.Text }}</button>&nbsp;
    </mat-dialog-actions>
</div>

